import { Form } from 'antd';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useSectors } from '@/hooks/v1/useSectors';

interface SectorProps {
	fieldName?: string | string[];
}

const { useFormInstance, useWatch } = Form;

export function useSector({ fieldName }: SectorProps) {
	const form = useFormInstance();
	const { organization } = useApplicationContext();

	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const companyId = useWatch(field ? [field, 'company_id'] : 'company_id');
	const sectorId = useWatch(field ? [field, 'sector_id'] : 'sector_id');

	const {
		isFetching,
		data: sectors,
		isError
	} = useSectors({
		organizationId: organization.id!,
		companyId: companyId
	});

	const isDisabled = !companyId;

	function handleSectorSelect(id: string): void {
		form.setFieldValue(field ? [field, 'sector_id'] : ['sector_id'], id);
		form.setFieldValue(field ? [field, 'line_id'] : ['line_id'], undefined);
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
		form.setFieldValue(field ? [field, 'activity_id'] : ['activity_id'], undefined);
	}

	function handleClearSector(): void {
		form.setFieldValue(field ? [field, 'sector_id'] : ['sector_id'], undefined);
		form.setFieldValue(field ? [field, 'line_id'] : ['line_id'], undefined);
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
		form.setFieldValue(field ? [field, 'activity_id'] : ['activity_id'], undefined);
	}

	const items =
		sectors?.map((sector: { id: string; name: string }) => ({
			value: sector.id,
			label: sector.name
		})) || [];

	return {
		items,
		sectorId,
		isFetching,
		isError,
		isDisabled,
		handleSectorSelect,
		handleClearSector
	};
}
